<template lang="pug">
.cart-item.play-card-item
  .summary__line
    .summary__prod.summary__prod--left
      p {{ getProductTitle() }}
      template(v-for="(count, name) in payload.options.upgrades || {}")
        p(v-if="count") {{ upgrades.find(x => x.name == name).title }} {{ count }}
      p.summary__time.hidden
      p.summary_time-hide
      a.summary__edit(href='#' @click.prevent="itemEdit($event)") Edit
      a.summary_delete-hide.summary__edit(href='#' @click.prevent="itemDelete($event)") DELETE
    .summary__prod
      p -
    .summary__prod
      p.summary__price-sp.nowrap {{ price | currency }}
      p.summary__subtotal-price-hide.nowrap {{ (price + Number(item.attributes.product.tax)) * item.payload.count | currency }}
      .summary__calc
        button.minus-count.summary__minus(v-if="!item.attributes.disableCountControls" :class="{ disabled: item.payload.count <= 1 }" @click="setCount(item.payload.count - 1)")
        p.nowrap {{ item.payload.count }}
        button.plus-count.summary__plus(v-if="!item.attributes.disableCountControls" @click="setCount(item.payload.count + 1)")
    .summary__prod.summary__price
      p.nowrap {{ price | currency }}
    .summary__prod
      p.nowrap {{ price * item.payload.count | currency }}
    .summary__prod
      p.nowrap {{ item.attributes.product.tax * item.payload.count | currency }}
    .summary__prod.summary__prod--right.summary__prod--last
      p.nowrap {{ (price + Number(item.attributes.product.tax)) * item.payload.count | currency }}
      button.summary__remove-product(@click.prevent="itemDelete($event)")
</template>

<script>
const EventBus = window.VueEventBus
import PageMixins from '../../components/_mixins/pages'
import CartMixins from '../../components/_mixins/location-checkout'
import DatesMixin from '../../components/_mixins/dates'

export default {
  name: 'playcard-voucher-cart-item',
  settings: 'page.cart',
  translations: 'page.cart',
  mixins: [
    PageMixins,
    CartMixins,
    DatesMixin,
  ],

  props: {
    item: {},
    items: {},
    groupedItems: {},
    cartView: {},
    showItemRates: {
      default: false
    },
  },

  computed: {
    payload() {
      return this.item.payload
    },
    upgrades() {
      return this.item.attributes.product.upgrades
    },
    price() {
      return Number(this.item.attributes.product.price) +
        Object.entries(this.item.payload.options.upgrades || {})
            .map(([name, count]) => this.upgrades.find(u => u.name == name).price * count)
            .reduce((sum, a) => sum + a, 0)
    },
  },

  methods: {
    itemDelete($event) {
      const item = this.item
      this.cartView.cartItemButtonClicked({
        $event,
        actionName: 'delete',
        id: this.item.id,
        item,
        cartItems: this.currentCartItems,
        button: {
          onDelete: this.onDelete
        }
      })

      EventBus.$emit('cart-item-deleted', item, this, this.$parent)
      EventBus.$emit('cart-item-deleted-' + item.type, item, this, this.$parent)
    },

    itemEdit($event) {
      const item = this.item
      this.cartView.cartItemButtonClicked({
        $event,
        item,
        actionName: 'edit',
        id: this.item.id,
        cartItems: this.currentCartItems,
        button: {}
      })
      EventBus.$emit('cart-item-edit', item, this, this.$parent)
      EventBus.$emit('cart-item-edit-' + item.type, item, this, this.$parent)

      this.$router.push({ name: 'supercharged.buy-play-card', query: { item: item.id } })
    },

    onDelete(args) {
      const { item } = args

      if (item.payload.options.child_ids) {
        this.onDeleteFirstItem(item)
      }
      if (item.payload.options.parent_id) {
        this.onDeleteChildItem(item)
      }
    },

    onDeleteFirstItem(item) {
      if (item.payload.options.child_ids.length) {
        const newFirstItem = _.cloneDeep(this.cartItems[item.payload.options.child_ids[0]])
        newFirstItem.payload.options.child_ids = item.payload.options.child_ids.slice(1)
        for (const childId of item.payload.options.child_ids) {
          const childItem = _.cloneDeep(this.cartItems[childId])
          childItem.payload.options.parent_id = newFirstItem.id
          this.removeCartItem(childItem)
          this.addCartItem(childItem)
        }
        delete newFirstItem.payload.options.parent_id
        // delete newFirstItem.attributes.skipCartCount
        this.removeCartItem(newFirstItem)
        this.addCartItem(newFirstItem)
      }
    },

    onDeleteChildItem(item) {
      const parentItem = _.cloneDeep(this.cartItems[item.payload.options.parent_id])

      parentItem.payload.options.child_ids
        .splice(parentItem.payload.options.child_ids.indexOf(item.id), 1)

      this.removeCartItem(parentItem)
      this.addCartItem(parentItem)
    },

    setCount(count) {
      EventBus.$emit('cart.validating', true)
      this.setCartItemCount({ id: this.item.id, count })
      EventBus.$$emitAsync('cart.validate')
      EventBus.$emit('cart.validating', false)
    },
    getProductTitle() {
      const item = this.item
      const title = item.attributes.product.title
      return title.replace(/play card/ig, this.PLAYCARD_TC)
    },
  }
}
</script>
